import { mapSenderLegacyPath } from '@/lib/map-sender-legacy-path';
import { useEffect } from 'react';
import { Link, useLocation } from 'react-router';

export default function SenderLegacyRedirect() {
	const location = useLocation();

	useEffect(() => {
		const target = mapSenderLegacyPath(`${location.pathname}${location.search}`);
		window.location.replace(target);
	}, [location.pathname, location.search]);

	return (
		<div className='flex min-h-[40vh] flex-col items-center justify-center gap-3 px-4 text-center'>
			<p className='text-sm text-muted-foreground'>Sender переехал в отдельное приложение…</p>
			<Link to='/sender-app/' className='text-sm font-medium text-chart-2 underline-offset-4 hover:underline'>
				Открыть Sender WebApp
			</Link>
		</div>
	);
}
